<div
  class="question"
  *ngIf="data.status === 'Active' && localStoreBusSeatID !== data.id"
>
  <div class="title">
    如果您在登录 {{ data.bus.platform.name }} 时遇到问题，请查看工单
  </div>
  <div class="detail">
    <img
      src="../../../../assets/images/workorder/Icon1.webp"
      alt=""
      [width]="22"
      [height]="22"
    />
    <span class="text" (click)="openAferSalesModal()">
      查看 {{ data.bus.platform.name }} 工单系统
    </span>
  </div>
</div>
<div
  class="question"
  *ngIf="
    data.work_order_status === 'Repair' ||
    (data.status === 'Active' && localStoreBusSeatID === data.id)
  "
  [formGroup]="formGroup"
>
  <div class="title">
    我们目前正在修复您的{{ data.bus.platform.name }}帐户。<br />
    请耐心等待 24小时
  </div>
  <ng-container *ngIf="flagSolve">
    <div class="subtitle">您的问题是否解决？</div>
    <div class="buttons">
      <button matRipple (click)="solve(1)">是</button>
      <button matRipple (click)="solve(2)">否</button>
    </div>
  </ng-container>
  <ng-container *ngIf="!flagSolve">
    <div class="subtitle">请详细描述您的问题：</div>
    <div class="input">
      <textarea formControlName="detail"></textarea>
      <app-image-uploader-qiniu
        formControlName="icon"
        width="250px"
        height="100px"
        [ratio]="2.5"
      ></app-image-uploader-qiniu>
    </div>
    <div class="buttons" style="text-align: end">
      <button matRipple (click)="reply()">提交</button>
    </div>
  </ng-container>
</div>
<div class="question" *ngIf="list?.length">
  <div class="item" *ngFor="let item of list">
    <img
      src="../../../../assets/images/workorder/Icon2.webp"
      alt=""
      [width]="20"
      [height]="15"
    />
    <span class="remark">{{ item }} </span>
  </div>
</div>
